// A booking's origin is only encoded in its `code` prefix; there is no `source` field.
// Unknown prefixes are CUSTOM, never CUBE: numeric/legacy/test codes and external systems
// like iReserve are not X-Cube-touchscreen bookings.
export function matchBookingSource(code = "") {
    if (code.startsWith("XCUBE-")) return { tag: "CUBE", rest: code.slice(6) };
    if (code.startsWith("HUB-")) return { tag: "HUB", rest: code.slice(4) };
    if (code.startsWith("WEBSITE-ORDER-")) return { tag: "WEB", rest: code.slice(14) };
    if (code.startsWith("WEBSITE")) return { tag: "WEB", rest: code.replace(/^WEBSITE-?/, "") };
    if (code.startsWith("API")) return { tag: "API", rest: code.replace(/^API-?/, "") };
    return { tag: "CUSTOM", rest: code };
}

export function bookingSourceTag(code = "") {
    return matchBookingSource(code).tag;
}

export function bookingShortCode(code = "") {
    const { tag, rest } = matchBookingSource(code);
    // XCUBE codes are short and meaningful in full; the rest are long hashes/ids → cap at 8.
    return tag === "CUBE" ? rest : rest.slice(0, 8);
}
